/**
 * Owner: Masa Bayu
 * File: public-author-follow-store.ts
 * Date:Time: 2026-10-18 21:40
 * Description: Simpanan "ikuti penulis" setempat (localStorage, per peranti) —
 *   kelakuan sebenar butang Follow; hub belum ada endpoint follow.
 */

const FOLLOW_STORAGE_KEY = 'qxread:author-follows:v1';

const listeners = new Set<() => void>();

function readStored(): readonly string[] {
  try {
    const raw = window.localStorage.getItem(FOLLOW_STORAGE_KEY);
    if (typeof raw !== 'string') {
      return [];
    }
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return Object.freeze(parsed.filter((item): item is string => typeof item === 'string'));
  } catch {
    return [];
  }
}

let snapshot: readonly string[] = readStored();

function emit(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function subscribeAuthorFollows(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getAuthorFollowSnapshot(): readonly string[] {
  return snapshot;
}

export function toggleAuthorFollow(authorId: string): boolean {
  const following = snapshot.includes(authorId);
  const next = following
    ? Object.freeze(snapshot.filter((id) => id !== authorId))
    : Object.freeze([...snapshot, authorId]);
  snapshot = next;
  try {
    window.localStorage.setItem(FOLLOW_STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* storan penuh/peribadi — keadaan memori kekal untuk sesi ini */
  }
  emit();
  return !following;
}
